
import { Inject, Injectable } from '@nestjs/common';
import { DataSource } from 'typeorm';
import { InjectDataSource } from '@nestjs/typeorm';
import { CategoryIdRequest, CommonResponseModel } from '@project-management-system/shared-models';
import { ContentRepo } from './dto/content-repo';
import { ContentEntity } from './dto/content-entity';
import { ContentDto } from './dto/content-dto';
import { M3TrimsCategoryMappingRepo } from '../../m3-trims/m3-trims-category-mapping.repo';
import { CategoryMappingEntity } from '../../m3-trims/m3-trims-category-mapping.entity';
import { Plants } from '../../plants/plants.entity';
@Injectable()

export class ContentService{
    @InjectDataSource()
    private datasource: DataSource
    constructor(
        private contentRepo:ContentRepo,
        private m3TrimsCategoryMappingRepo:M3TrimsCategoryMappingRepo

    ){}

    async createContent(req: ContentDto, isUpdate: boolean): Promise<CommonResponseModel> {
        try {
            const manager = this.datasource;
            let existingCategoryCode;
            if(!isUpdate){
                const query=` SELECT  trim_category,c.content FROM category_mapping cm
                LEFT JOIN content c ON c.content_id = cm.content_id 
                where c.content ='${req.content}' AND cm.trim_category = ${req.trimCategoryId}`
                const existingCategory = await manager.query(query)
                if (existingCategory.length > 0 ) {
                    throw new Error('Category Already Exists');
                } else if (existingCategoryCode) {
                    throw new Error('Category Code already exists');
                }
            }
            else{
                const contentDetails = await this.contentRepo.findOne({ where: { content: req.content } })
                if (contentDetails) {
                    return new CommonResponseModel(false, 1, 'Content already exists')
                } 
                const details = await this.contentRepo.findOne({ where: { content: req.content } })
                if (details) {
                    return new CommonResponseModel(false, 1, 'Content Code already exists')
                } 
            }
            const entity = new ContentEntity();
            entity.content = req.content;
            entity.itemType = req.itemType
            const entities= new Plants();
            entities.plantId=req.plantId
            entity.plantInfo = entities
            if (isUpdate) {
                entity.updatedUser = req.createdUser;
                entity.contentId = req.contentId;
            } else {
                entity.createdUser = req.createdUser;
            }
    
            const save = await this.contentRepo.save(entity);
    
            if (save && !isUpdate) {
                let reqData = new CategoryMappingEntity();
                reqData.trimCategory = req.trimCategoryId;
                reqData.contentId = save.contentId;
                // console.log(reqData)
                const mapCategory = await this.m3TrimsCategoryMappingRepo.save(reqData);
                // console.log(mapCategory);
                if(mapCategory.categoryMappingId > 0){
                    return new CommonResponseModel(true, 1, isUpdate ? 'Content Updated Successfully' : 'Content Created Successfully',save);
                }
                else{
                    return new CommonResponseModel(false, 0, "Something went wrong. ")
                }
            } 
            else if (save && isUpdate) {
                return new CommonResponseModel(true, 1, isUpdate ? 'Content Updated Successfully' : 'Content Created Successfully',save);
            }
            else {
                return new CommonResponseModel(false, 0, 'Something Went Wrong');
            }
        } catch (err) {
            // Handle the error appropriately, e.g., log or rethrow
            throw err;
        }
    }
    

    async getAllContent():Promise<CommonResponseModel>{
        const style = await this.contentRepo.find({
            order:{content:'ASC'},relations:["plantInfo"]
        })
        // console.log(style);
        if(style.length >0){
            return new CommonResponseModel(true,1,'Active Contents Retrived Sucessfully',style)
        }else{
            return new CommonResponseModel(false,0,'No  Content Found ',[])

        }

    }
    async getAllActiveContent():Promise<CommonResponseModel>{
        const style = await this.contentRepo.find({
            where:{isActive:true},
            order:{content:'ASC'}
        })
        // console.log(style);
        if(style.length >0){
            return new CommonResponseModel(true,1,'Active content Retrived Sucessfully',style)
        }else{
            return new CommonResponseModel(false,0,'No  Content Found ',[])

        }

    }

    async getContentById(contentId: number): Promise<ContentEntity> {
        const Response = await this.contentRepo.findOne({
        where: {contentId: contentId},
        });
        if (Response) {
        return Response;
        } else {
        return null;
        }
    } 

  async activateOrDeactivateContent(req: ContentDto): Promise<CommonResponseModel> {
    try {
        const Exist = await this.getContentById(req.contentId);
        if (Exist) {
            if (!Exist) {
                throw new CommonResponseModel(false,10113, 'Someone updated the current   Content information.Refresh and try again');
            } else {
                
                    const Status =  await this.contentRepo.update(
                        { contentId: req.contentId },
                        { isActive: req.isActive,updatedUser: req.updatedUser });
                   
                    if (Exist.isActive) {
                        if (Status.affected) {
                            const Response: CommonResponseModel = new CommonResponseModel(true, 10115, 'Content is Deactivated successfully');
                            return Response;
                        } else {
                            throw new CommonResponseModel(false,10111, 'Content is already deactivated');
                        }
                    } else {
                        if (Status.affected) {
                            const response: CommonResponseModel = new CommonResponseModel(true, 10114, 'Content is Activated successfully');
                            return response;
                        } else {
                            throw new CommonResponseModel(false,10112, 'Content is already  activated');
                        }
                    }
                // }
            }
        } else {
            throw new CommonResponseModel(false,99998, 'No Records Found');
        }
    } catch (err) {
        return err;
    }
}

async getFabricContentData():Promise<CommonResponseModel>{
    try{
      let query = `
      SELECT content, item_type as itemType, content_id as contentId
      FROM content
      WHERE item_type = 'Fabric' and is_active = true`
      const data = await this.datasource.query(query)
      if(data.length>0){
        return new CommonResponseModel(true, 0, 'Data retrieved successfully',data)
      }else{
        return new CommonResponseModel(false, 1, 'No data found',[])
      }
    }catch(err){
      throw(err)
    }
  }

  async getAllContentForCategory(req:CategoryIdRequest):Promise<CommonResponseModel>{
    try{
        let data = await this.m3TrimsCategoryMappingRepo.getAllContentByCategory(req.categoryId)
        if(data.status){
          return new CommonResponseModel(true, 0, 'Data retrieved successfully',data.data)
        }else{
          return new CommonResponseModel(false, 1, 'No data found',[])
        }
      }catch(err){
        throw(err)
      }
  }

  
}
